import CancelledCommandException from "../Core/Scheduler/CancelledCommandException";
export default {
  executeCommand: function executeCommand(command) {
    var promises = [];
    var layer = command.layer;
    var requester = command.requester;
    var extentsSource = command.extentsSource;

    if (requester && !requester.material) {
      return Promise.reject(new CancelledCommandException(command));
    }

    for (var i = 0, size = extentsSource.length; i < size; i++) {
      promises.push(layer.convert(requester, extentsSource[i]));
    }

    return Promise.all(promises);
  }
};